export default "__VITE_ASSET__CiSyVVFs__"